import { IComboBoxOption, IIconProps } from "@fluentui/react";
import TimeTaxSupportSystemClient from "../../system";
import MessageCourier from "../../lib/MessageCourier";
import { User } from "../../system/User";
import { IActivityRecurring, ItipoConcepto } from "../../system/projects/ProjectsSystem";
import { AiActivityEnhancementSystem } from "../../system/ai/AiActivityEnhancementSystem";
import { DateTime } from "luxon";

export interface IMyDetailsList {
  addRows:IAddRows[];
  listCompanies:any[];
  filterTipoConsept:ItipoConceptoGrid[];
  aiActivityEnhancementSystem: AiActivityEnhancementSystem;
  onselectCountry:(option: IComboBoxOption | undefined, id: string) => Promise<void> ;
  countryFilterChange: (text: string, id: string) => void;
  onselectCompany: (option: IComboBoxOption | undefined, id: string) => Promise<void>;
  companyFilterChange: (text: string, id: string) => void;
  onselecTipoConcept: (option: ItipoConcepto | undefined, id: string) => Promise<void>;
  tipoConceptFilterChange:(text: string, id: string) => void;
  onselectProject: (option: IComboBoxProject | undefined, id: string, inputText: string | undefined) => Promise<void>;
  ProjectFilterChange:(text: string, id: string, listaProyect: IComboBoxOptionGrid[]) => void;
  HandlerNombreAct:(option: IActivityRecurringGrid, id: string, newValue: string | undefined) => void;
  HandlerNombreActNuevo:(id: string, text: string) => void;
  handlerDescripcion:(data: string | undefined, id: string, tempRows?:IAddRows[]) => void;
  HandlerContHoras:(id: string, newValue: string | undefined, type: "hour" | "minute") => void;
  handlerDuplicateRow:(data: any) => void;
  HandlerDeleteRows:(id: string) => void;
  loading:boolean;
  onClickCallout: (id: string) => void;
  updateActivityNameAndDescription: (id: string, newNombreAct: string, newDescripcion: string) => void,
  handleMultipleFiles: (fileList: File[], project: IComboBoxOption, rowId: string) => void;
  handleFileDelete: (index: number, rowId: string) => void;
  HandlerAddRows:(number: number) => void;
  HandlerContOnlyMinute:(newValue: IComboBoxOptionGrid, id: string) => void;
  HandlerPasteData:(data: any[][]) => void;
  HandlerDeleteData:(data: any[][]) => void;
  HandlercleanEverything:() => void;
  handleSelectedRowsChange: (rowIds: IAddRows[]) => void;
  countAddRows: number;
  selectedRowsMain:IAddRows[];
}

export interface ICompanyPanel {
    system: TimeTaxSupportSystemClient;
    courier: MessageCourier;
    changeBlockUI: (change: boolean) => void;
    user: User;
    useAllSector?: boolean;
  };
export interface IAddRows {
    id: string;
    nombrePro: IComboBoxInput;
    nombreAct: string;
    horasCarg: string;
    file: string;
    files: File[]
    valida: number;
    descripcionError: string;
    actividadRecurrente: string;
    lisActRecurrente: IActivityRecurringGrid[];
    actividadRecurrenteSelect?:IActivityRecurringGrid;
    comapaniesSelect?: IComboBoxOptionGrid[];
    tipoConcepto:ItipoConcepto;
    listaProyectos:IComboBoxOptionGrid[];
    filterListProyectos: IComboBoxProject[];
    // listaProyectos:IComboBoxOption[];
    // filterListProyectos:IComboBoxInput[];
    descripcion:string;
    paisEmpresa:IComboBoxInput,
    nombreEmp:IComboBoxInput,
    listaEmpresa:IComboBoxOption[],
    options:number,
    minuteCarg: string;
}

export interface IactError {
  actVali:number;
  actvErro:number;
}

export interface ICollaborator {
  id: string;
  name: string;
  lastName: string;
  email: string;
  active: boolean;
}

export interface IComboBoxInput extends IComboBoxOption{
  code?: string;
  pro_inicio?: DateTime
  pro_fin?: DateTime;
}

export interface IComboBoxOptionGrid{
  value: string | number;
  label: string;
}

export interface ItipoConceptoGrid extends IComboBoxOptionGrid{
  codigo?:string;
}

export interface IComboBoxProject extends IComboBoxOptionGrid{
  code?: string;
  pro_inicio?: DateTime
  pro_fin?: DateTime;
}

export interface IActivityRecurringGrid extends IComboBoxOptionGrid{
  ar_id:string;
  ar_proy_id: string;
  ar_nombre_act: string;
  ar_nombre_descripcion: string;
  ar_user_modified: string;
  ar_user_created: string;
  ar_date_modified: Date;
  ar_date_created: Date;
  ar_activo: number;
  ar_eliminado: number;
  ar_pais_id: number;
  ar_empresa_id: number;
}

export const UploadIcon: IIconProps = { iconName: 'Upload' };
export const AddIcon: IIconProps = { iconName: 'add' };